export interface Site {
  id: string;
  userId: string;
  name: string;
  subdomain: string;
  customDomain: string | null;
  isPublished: boolean;
  isLandingPage: boolean;
  userName: string;
  userEmail: string;
  createdAt: string;
  updatedAt: string;
}

export interface EditFormData {
  name: string;
  subdomain: string;
  customDomain: string;
}

export const INITIAL_EDIT_FORM: EditFormData = {
  name: '',
  subdomain: '',
  customDomain: '',
};
